"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteCurrencyForBiFromViewerModel = void 0;
const win_1 = require("./win");
/**
 * Returns currency from viewerModel.
 * Should be used only for BI purposes to get site currency.
 * Useful in case of multicurrency - when payment goes not in the original
 * site currency but we need to know main currency on the site.
 */
const getSiteCurrencyForBiFromViewerModel = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    return (
    // @ts-expect-error
    ((_c = (_b = (_a = win_1.win === null || win_1.win === void 0 ? void 0 : win_1.win.viewerModel) === null || _a === void 0 ? void 0 : _a.siteFeaturesConfigs) === null || _b === void 0 ? void 0 : _b.siteWixCodeSdk) === null || _c === void 0 ? void 0 : _c.currency) ||
        (
        // @ts-expect-error
        (_g = (_f = (_e = (_d = win_1.win === null || win_1.win === void 0 ? void 0 : win_1.win.viewerModel) === null || _d === void 0 ? void 0 : _d.siteFeaturesConfigs) === null || _e === void 0 ? void 0 : _e.tpaCommons) === null || _f === void 0 ? void 0 : _f.extras) === null || _g === void 0 ? void 0 : _g.currency) ||
        '');
};
exports.getSiteCurrencyForBiFromViewerModel = getSiteCurrencyForBiFromViewerModel;
//# sourceMappingURL=getSiteCurrencyFromViewerModel.js.map